import FileListBookmarks from './FileListBookmarks';
import './FileListBookmarks.scss';

export default FileListBookmarks;
